import { isMobile } from '@utils/screen';

export const disableScaleInMobile = () => {
  if (isMobile()) {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'viewport');
    meta.setAttribute('content', 'width=device-width,initial-scale=1,user-scalable=0');
    document.head.appendChild(meta);
  }
};
